export default __webpack_public_path__ + "images/assets/e417638d5211a0f6a782c90169eb8ffb.svg";